<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    <v-row justify="center">
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">Reportes</p>
          </v-card-title>

          <v-card-text>
            <v-row justify="center">
              <v-col cols="4">
                <v-select
                  dense
                  outlined
                  label="Competencia"
                  :items="competencias"
                  item-value="id"
                  item-text="competencia"
                  return-object
                  v-model="competencia"
                  :rules="competenciaReglas"
                  @change="actualizarDatosCompetencia"
                >
                </v-select>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Categoria"
                  :items="categoriasCompetencia"
                  item-value="id"
                  item-text="categoria"
                  v-model="categoria"
                >
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Saber"
                  :items="saberesCompetencia"
                  item-value="id"
                  item-text="saber"
                  v-model="saber"
                >
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Regional"
                  :items="regionales"
                  item-value="id"
                  item-text="regional"
                  v-model="regional"
                  @change="actualizarDatosRegional"
                >
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Centro de formación"
                  :items="centrosFormacion"
                  item-value="id"
                  item-text="centro_formacion"
                  v-model="centroFormacion"
                >
                </v-autocomplete>
                <v-checkbox v-model="campesena" label="Cupos" value="cupos">
                </v-checkbox>

                <v-checkbox
                  v-model="campesena"
                  label="Participantes"
                  value="participantes"
                >
                </v-checkbox>

                <v-checkbox v-model="campesena" label="Lideres" value="lideres">
                </v-checkbox>

                <v-checkbox
                  v-model="campesena"
                  label="Categorias"
                  value="categorias"
                >
                </v-checkbox>
                <v-checkbox v-model="campesena" label="Saberes" value="saberes">
                </v-checkbox>

                <v-btn
                  large
                  block
                  exact
                  elevation="2"
                  color="primary"
                  class="mt-2 mb-6"
                  @click="reporteCampesena"
                >
                  Descargar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    competencia: null,
    categoria: null,
    saber: null,
    regional: null,
    centroFormacion: null,
    competenciaReglas: [(v) => !!v || "Seleccione una competencia"],

    campesena: [],
  }),

  components: {
    Alert,
  },

  mounted() {
    this.$store.dispatch("gestionarCompetenciasCampesena");
    this.$store.dispatch("gestionarCategoriasCampesena");
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
  },

  computed: {
    competencias() {
      return this.$store.getters.obtenerCompetenciasCampesena;
    },
    categoriasCompetencia() {
      const categorias = this.$store.getters.obtenerCategoriasCampesena;
      return categorias.filter((categoria) =>
        this.saberesCompetencia.some(
          (saberes) => categoria.id === saberes.categoria_id
        )
      );
    },
    saberesCompetencia() {
      const saberes = this.$store.getters.obtenerSaberesCompetencia;
      if (this.categoria) {
        return saberes.filter(
          (saberes) => saberes.categoria_id == this.categoria
        );
      }
      return this.$store.getters.obtenerSaberesCompetencia;
    },
    regionales() {
      return this.$store.getters.obtenerRegionales;
    },
    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacionReporte(this.regional);
    },
  },
  methods: {
    actualizarDatosCompetencia() {
      this.$store.dispatch("gestionarSaberesCompetencia", this.competencia.id);
    },
    actualizarDatosCategoria() {
      this.$store.dispatch("gestionarSaberesCompetencia", this.competencia.id);
    },
    actualizarDatosRegional() {
      this.$store.dispatch("crearCentrosFormacion");
    },
    reporteCampesena() {
      if (this.competencia) {
        if (this.campesena.length > 0) {
          const reporte = {
            competencia: this.competencia.id,
            saber: this.saber,
            categoria: this.categoria,
            regional: this.regional,
            centro_formacion: this.centroFormacion,
            datos: this.campesena,
          };

          this.$store
            .dispatch("descargarCampesenaReporte", reporte)
            .then((response) => {
              const urlReporte = window.URL.createObjectURL(
                new Blob([response])
              );
              const link = document.createElement("a");
              link.href = urlReporte;
              link.setAttribute(
                "download",
                `${this.competencia.competencia}.xlsx`
              );
              document.body.appendChild(link);
              link.click();
              this.campesena = [];
              this.alertTitle = "Descargado";
              this.alertMessage = "Reporte con éxito";
              this.alertType = "success--text";
              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 1000);
            })
            .catch(() => {});
        } else {
          this.alertTitle = "Error";
          this.alertType = "error--text";
          this.alertMessage = "Seleccione items para descargar";
          this.titleCard = "error--text";
          this.alert = true;
        }
      } else {
        this.alertTitle = "Error";
        this.alertType = "error--text";
        this.alertMessage = "Seleccione una competencia";
        this.titleCard = "error--text";
        this.alert = true;
      }

      setTimeout(() => {
        this.alert = false;
      }, 2000);
    },
  },
};
</script>
